const MatchData = [{
    id: 1,
    imgSrc: "https://img.freepik.com/free-photo/three-young-beautiful-smiling-girls-trendy-summer-casual-jeans-clothes-sexy-carefree-women-posing-positive-models-sunglasses_158538-4730.jpg?size=626&ext=jpg&ga=GA1.2.1116955289.1658019530",
    name: "Jane Doe",
    age: "21",
    year: "Junior",
    major: "Computer Science",
},
{
    id: 2,
    imgSrc: "https://img.freepik.com/free-photo/pretty-red-head-woman-yellow-dress-posing-yellow-summer-mood_273443-4421.jpg?size=626&ext=jpg&ga=GA1.2.1116955289.1658019530",
    name: "Jane Doe",
    age: "21",
    year: "Junior",
    major: "Computer Science",
},
{
    id: 3,
    imgSrc: "https://img.freepik.com/free-photo/male-tourist-orange-glasses-relaxes-sitting-chair-drinking-beer-guy-green-shirt-poses-with-suitcase-inflatable-mattress-pineapple-orange-background_197531-27422.jpg?size=626&ext=jpg&ga=GA1.2.1116955289.1658019530",
    name: "Jane Doe",
    age: "21",
    year: "Junior",
    major: "Computer Science",
},
{
    id: 4,
    imgSrc: "https://img.freepik.com/free-photo/two-young-beautiful-smiling-blond-hipster-girls-trendy-summer-colorful-t-shirt-clothes_158538-1038.jpg?size=626&ext=jpg&ga=GA1.2.1116955289.1658019530",
    name: "Jane Doe",
    age: "21",
    year: "Junior",
    major: "Computer Science",
},
{
    id: 5,
    imgSrc: "https://img.freepik.com/free-photo/portrait-handsome-smiling-young-man-model-wearing-casual-summer-pink-clothes-fashion-stylish-man-posing-round-sunglasses_158538-5346.jpg?size=626&ext=jpg&ga=GA1.2.1116955289.1658019530",
    name: "Jane Doe",
    age: "21",
    year: "Junior",
    major: "Computer Science",
},
{
    id: 6,
    imgSrc: "https://img.freepik.com/free-photo/portrait-young-stylish-girl-model-casual-summer-clothes-brown-hat-with-natural-makeup-isolated_158538-8586.jpg?size=626&ext=jpg&ga=GA1.2.1116955289.1658019530",
    name: "Jane Doe",
    age: "21",
    year: "Junior",
    major: "Computer Science",
},
{
    id: 7,
    imgSrc: "https://img.freepik.com/free-photo/amazing-blonde-woman-trendy-summer-outfit-posing-outdoors_273443-3070.jpg?size=626&ext=jpg&ga=GA1.2.1116955289.1658019530",
    name: "Jane Doe",
    age: "21",
    year: "Junior",
    major: "Computer Science",
},
{
    id: 8,
    imgSrc: "https://img.freepik.com/free-photo/woman-posing-isolated-yellow-wearing-black-dotted-dress-black-hat-stylish-spring-summer-fashion-style-accessories-smiling-happy-mood-having-fun_285396-10286.jpg?size=626&ext=jpg&ga=GA1.2.1116955289.1658019530",
    name: "Jane Doe",
    age: "21",
    year: "Junior",
    major: "Computer Science",
    },
    {
        id: 9,
        imgSrc: "https://img.freepik.com/free-photo/portrait-handsome-smiling-young-man-model-wearing-casual-summer-pink-clothes-fashion-stylish-man-posing-round-sunglasses_158538-5346.jpg?size=626&ext=jpg&ga=GA1.2.1116955289.1658019530",
        name: "Jane Doe",
        age: "21",
        year: "Junior",
        major: "Computer Science",
    },
    {
        id: 10,
        imgSrc: "https://img.freepik.com/free-photo/portrait-young-stylish-girl-model-casual-summer-clothes-brown-hat-with-natural-makeup-isolated_158538-8586.jpg?size=626&ext=jpg&ga=GA1.2.1116955289.1658019530",
        name: "Jane Doe",
        age: "21",
        year: "Junior",
        major: "Computer Science",
    },
    {
        id:11,
        imgSrc: "https://img.freepik.com/free-photo/amazing-blonde-woman-trendy-summer-outfit-posing-outdoors_273443-3070.jpg?size=626&ext=jpg&ga=GA1.2.1116955289.1658019530",
        name: "Jane Doe",
        age: "21",
        year: "Junior",
        major: "Computer Science",
    },
    {
        id: 12,
        imgSrc: "https://img.freepik.com/free-photo/woman-posing-isolated-yellow-wearing-black-dotted-dress-black-hat-stylish-spring-summer-fashion-style-accessories-smiling-happy-mood-having-fun_285396-10286.jpg?size=626&ext=jpg&ga=GA1.2.1116955289.1658019530",
        name: "Jane Doe",
        age: "21",
        year: "Junior",
        major: "Computer Science",
    },
];

export default MatchData;